// РУКА 2 (по решению Имы, 22.10). Скрытый вход в админку: пять нажатий на логотип за 5 секунд.
// Чистая функция — проверяется тестом. Сам вход в админку по-прежнему по коду (сотрудник или разработчик).
export const TAPS_NEEDED = 5
export const TAPS_WINDOW_MS = 5000 // 3 секунды не хватало на пять спокойных нажатий

/** Учесть нажатие в момент now. fire — пора открыть админку; после срабатывания счёт сначала. */
export function countTap(taps: number[], now: number): { taps: number[]; fire: boolean } {
  const recent = [...taps.filter((t) => now - t < TAPS_WINDOW_MS), now]
  if (recent.length >= TAPS_NEEDED) return { taps: [], fire: true }
  return { taps: recent, fire: false }
}
